export const appConfig = {
  uiUrl: 'https://dev-pecr.carrier.com/',
  apiUrl: 'https://api.carrierappshub1.com/',
  postLogoutRedirectUri: 'http://localhost:3000',
};
